import React, { memo } from "react";
import { Link as RouterLink } from "react-router-dom";

import { useStore } from "src/store";
import { getQs } from "src/utils";

export const Link = memo(props => {
  const { to, href, ...rest } = props;

  const store = useStore("config");
  const { variant, brand } = store("config");

  const link = to || href;
  const isRelative = link && !/^((f|ht)tps?:)?\/\//i.test(link);

  return isRelative ? <RouterLink to={link === "/" ? link + getQs({ variant, brand }) : link} {...rest} /> : <a href={link} {...rest} />;
});
